export const queryKeys = {
  keywordLists: 'keywordLists',
  keywordsTable: 'keywordsTable',
  masterPresets: 'masterPresets',
  masterPresetSectionPrompts: 'masterPresetSectionPrompts',
  articles: 'articles',
  articleTags: 'articleTags',
  promptConfigPresets: 'promptConfigPresets',
  sectionPromptPresets: 'sectionPromptPresets',
  chatPromptPresets: 'chatPromptPresets',
  articleWithKeywordData: 'articleWithKeywordData',
  headingPresets: 'headingPresets',
  contentReplacerPresets: 'contentReplacerPresets',
  featureUsage: 'featureUsage',
  gsc: {
    accounts: 'gscAccounts',
    sites: 'gscSites',
    siteFullDetails: 'gscSiteFullDetails',
    filterPresets: 'gscFilterPresets',
  },
  rankTracker: {
    root: 'rankTracker',
    domains: 'domains',
    keywords: 'keywords',
    domainKeywordsById: 'domainKeywordsById',
    allKeywordsByDomainId: 'allKeywordsByDomainId',
  },
  backlinks: 'backlinks',
  userList: 'userlist',
  agencies: 'agencies',
  agencySeatLimit: 'agencySeatLimit',
  user: 'user',
  pricing: 'pricing',
  articleConfig: 'articleConfig',
  subscriptions: 'subscriptions',
  featureAccess: 'featureAccess',
  citationTracker: {
    root: 'citationTracker',
    list: 'citationTrackerList',
    detail: 'citationTrackerDetail',
    searchTerms: 'citationSearchTerms',
  },
  gems: {
    cards: 'gemsCards',
    balance: 'gemsBalance',
    claimableActions: 'claimableActions',
    userClaims: 'userClaims',
    gemTransactions: 'gemTransactions',
    inviteeGemsDialog: 'inviteeGemsDialog',
    myReferralTokens: 'myReferralTokens',
    myTokenUsage: 'myTokenUsage',
    planNameFromInviteCode: 'planNameFromInviteCode',
  },
  referralToken: 'referralToken',
  eventConfigs: 'eventConfigs',
  inviteeGemsDialog: 'inviteeGemsDialog',
  wordpress: {
    sites: 'wordpressSites',
    site: 'wordpressSite',
    presets: 'wordpressUploadPresets',
    preset: 'wordpressUploadPreset',
    authors: 'wordpressAuthors',
    categories: 'wordpressCategories',
    seoPlugin: 'wordpressSeoPlugin',
  },
  aiImagePresets: 'aiImagePresets',
  gbpPostPresets: 'gbpPostPresets',
  gbpPostGenerations: 'gbpPostGenerations',
  gbpAIPromptPresets: 'gbpAIPromptPresets',
  admin: {
    plans: 'adminPlans',
    pricingCards: 'adminPricingCards',
    planFeatureLimits: 'adminPlanFeatureLimits',
    claimableActions: 'adminClaimableActions',
    userClaims: 'adminUserClaims',
    inviteCampaigns: 'adminInviteCampaigns',
    upsellChains: 'adminUpsellChains',
  },
  pluginVersionTracker: 'pluginVersionTracker',
};
